import get from 'lodash/get';

const NAMESPACE = 'products';

export const selectProducts = (state) => get(state, NAMESPACE, {});
